import { useEffect, useState } from "react";
import { api } from "../api";
import { useI18n } from "../i18n";
import { useToast } from "../ui";

/** nav badge + sound: polls the inbox summary; beeps and toasts when a new paid online order arrives */
export function useShopInbox(enabled: boolean): number {
  const { t } = useI18n();
  const toast = useToast();
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!enabled) return;
    let last = -1, stop = false;
    const tick = async () => {
      try {
        const s = await api<{ enabled: boolean; newCount: number; unseen: number }>("/api/shop/orders/summary");
        if (stop) return;
        setN(s.newCount);
        if (last >= 0 && s.unseen > last) { beep(); toast(t("shop.newOrderToast")); }
        last = s.unseen;
      } catch { /* offline: try again next tick */ }
    };
    void tick();
    const id = setInterval(() => void tick(), 30_000);
    return () => { stop = true; clearInterval(id); };
  }, [enabled]);
  return n;
}

function beep() {
  try {
    const Ctx = (window as unknown as { AudioContext?: typeof AudioContext; webkitAudioContext?: typeof AudioContext }).AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    [0, 0.18].forEach((at) => {
      const o = ctx.createOscillator(), g = ctx.createGain();
      o.frequency.value = 880; o.connect(g); g.connect(ctx.destination);
      g.gain.setValueAtTime(0.0001, ctx.currentTime + at); g.gain.exponentialRampToValueAtTime(0.25, ctx.currentTime + at + 0.02); g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + at + 0.15);
      o.start(ctx.currentTime + at); o.stop(ctx.currentTime + at + 0.16);
    });
    setTimeout(() => void ctx.close(), 800);
  } catch { /* autoplay blocked */ }
}
